import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DashboardServicesService } from 'src/app/_services/dashboard-services.service';

@Component({
  selector: 'app-tvdowloadinvoice',
  templateUrl: './tvdowloadinvoice.component.html',
  styleUrls: ['./tvdowloadinvoice.component.css'],
})
export class TvdowloadinvoiceComponent implements OnInit {
  userDetails = [
    { key: 'Name:', Value: 'Kristin Watson' },
    { key: 'Email:', Value: 'kristinwatson23@gmail.com' },
    { key: 'Mobile:', Value: '9876543210' },
    { key: 'Channel:', Value: 'Maa TV' },
    { key: 'No. of Programs:', Value: '2' },
    { key: 'Amount:', Value: '₹20,000.00' },
    { key: 'Due Date:', Value: '23-10-2022' },
    { key: 'Payment Mode:', Value: 'UPI' },
  ];
  queryParamsDetails: any;
  userDetailsParams: string;
  issueDialog: any;
  constructor(
    private services: DashboardServicesService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.queryParamsDetails = { ...params.keys, ...params };
      this.userDetailsParams = params.get('_id');
    });
    this.services
      .tvProgramRequestDetails(this.userDetailsParams)
      .subscribe((response) => {
        this.issueDialog = response.message;
      });
  }
}
